import { type ExcalidrawFontFaceDescriptor } from "../Fonts";

import ConsolasRegular from "./consola.ttf";

export const ConsolasFontFaces: ExcalidrawFontFaceDescriptor[] = [
  {
    uri: ConsolasRegular,
  },
];
